module.exports = __webpack_public_path__ + "img/ec-karte.f3891be.svg";